import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgLocationPinFilled = function SvgLocationPinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.4952 18.8883 14.8173 17.5726 16.7017C16.251 18.5946 14.6734 20.1174 13.6287 21.0297C12.6885 21.8509 11.3115 21.8509 10.3713 21.0297C9.32656 20.1174 7.749 18.5946 6.4274 16.7017C5.11171 14.8173 4 12.4952 4 10ZM8.875 10C8.875 8.27411 10.2741 6.875 12 6.875C13.7259 6.875 15.125 8.27411 15.125 10C15.125 11.7259 13.7259 13.125 12 13.125C10.2741 13.125 8.875 11.7259 8.875 10Z"
  })));
};

export { SvgLocationPinFilled as ReactComponent };
//# sourceMappingURL=location--pin-filled.svg.js.map
